import './index.scss'

// Redirect to https
let loc = window.location.href + ''

if (loc.indexOf('http://') == 0 && loc.indexOf('localhost') == -1){
  window.location.href = loc.replace('http://','https://')
}
